<template>
    <div class="constra-survey-container">
        <FAQComponent
        heading="FAQs"
        :faqs="constraFaqs"
        ></FAQComponent>
    </div>
</template>

<script>
import FAQComponent from "@/components/FAQComponent.vue"
import { constraFaqs } from "@/assets/db/faq-data"

export default {
    name: "ConstraFaqComponent",
    data() {
        return {
            constraFaqs
        }
    },
    components: {
        FAQComponent
    }
}
</script>